module.exports = __webpack_public_path__ + "img/shiyanshi.4ce594d4.png";